module.exports = __webpack_public_path__ + "img/ua.8553278a.svg";